import ApplicationSerializer from 'lumen/serializers/application';

export default class PrimaWarningValueSerializer extends ApplicationSerializer {
  // BE couldn't provide us with an "id" property in this object (:
  // Use this to tell the store that the "day_of_week" property can be used as a substitute
  primaryKey = 'day_of_week';
}
